import { REGISTER_TABS_GROUP, SET_ACTIVE_TAB } from "actions";

export const registerTabsGroup = (group: string) => ({
  type: REGISTER_TABS_GROUP,
  group,
});
export const setActiveTab = (group: string, tab: string) => ({
  type: SET_ACTIVE_TAB,
  group,
  tab,
});
